import React, { useEffect } from 'react';
import '../BillingStyle/ResourceSection.css';

const resources = [
  {
    icon: 'bi-speedometer2',
    iconColor: '#60A5FA',
    tag: 'Case Study',
    title: 'Driving Efficiency with Leading Billing Solutions',
    text: 'Discover how businesses have revolutionized their financial operations using advanced billing and payment software. From automating invoice generation to streamlining payment workflows, new opportunities for growth and operational excellence are unlocked.',
  },
  {
    icon: 'bi-receipt',
    iconColor: '#22D3EE',
    tag: 'Trend Report',
    title: 'The Role of Smart Invoicing in Business Growth',
    text: 'Explore the latest trends in billing and invoicing software enabling businesses to scale with confidence — automation, real-time payment processing, and advanced GST compliance that simplify financial management.',
  },
  {
    icon: 'bi-credit-card',
    iconColor: '#818CF8',
    tag: 'Analysis',
    title: 'Top Payment Solutions for Innovation',
    text: 'An in-depth analysis of the payment software landscape — comprehensive platforms for invoicing, recurring billing, and tax compliance that drive efficiency and ensure accuracy in financial processes.',
  },
];

const ResourceSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="resource-section-wrap">
    <div className="resource-section">
      <header className="resource-header" data-animate="slideUp">
        <h2 className="resource-main-title">Billing Resources</h2>
        <p className="resource-main-sub">Insights, case studies, and trends to keep your billing strategy ahead of the curve.</p>
      </header>

      <div className="resource-grid">
        {resources.map((resource, index) => (
          <div
            key={index}
            className="resource-card"
            data-animate="slideUp"
          >
            <div className="resource-card-header">
              <div className="resource-card-icon" style={{ color: resource.iconColor }}>
                <i className={`bi ${resource.icon}`}></i>
              </div>
              <span className="resource-card-tag">
                {resource.tag}
              </span>
            </div>
            <div className="resource-card-body">
              <h3 className="resource-card-title">{resource.title}</h3>
              <p className="resource-card-text">{resource.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="journey-section">
        <div className="journey-content" data-animate="slideInLeft">
          <h2 className="journey-title">Your Journey Starts Here</h2>
          <p className="journey-text">
            As your customers redefine how they engage with your products and services, your business
            must adapt to stay ahead. Discover how our cutting-edge Subscription Economy solutions
            empower the world's most forward-thinking businesses in the ever-evolving landscape of
            subscriptions.
          </p>
        </div>

        <div className="journey-cta-card" data-animate="slideInRight">
          <div className="journey-cta-icon">
            <i className="bi bi-people-fill"></i>
          </div>
          <h3 className="journey-cta-title">Want to Lead Change?</h3>
          <p className="journey-cta-text">
            Join our team that is transforming billing solutions in the world Economy subscription.
          </p>
          <div className="journey-cta-badges">
            <span className="journey-badge"><i className="bi bi-check-circle"></i> Remote Friendly</span>
            <span className="journey-badge"><i className="bi bi-graph-up"></i> Fast Growth</span>
            <span className="journey-badge"><i className="bi bi-heart"></i> Great Culture</span>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ResourceSection;
